export interface HomeDestination {
  name: string;
  image: string;
  carCount?: number;
}

export interface HomeDestinationResponse {
  countryCode?: string | null;
  destinations: Array<{ city: string; image: string | null; carCount: number }>;
}

/** Old responses were currency-filtered, not country-filtered. Never trust
 * those as national discovery content while the API rollout is pending. */
export function selectHomeDestinations(
  response: HomeDestinationResponse | undefined,
  countryCode: string | undefined,
  fallback: HomeDestination[],
): HomeDestination[] {
  const country = countryCode?.trim().toUpperCase();
  const verified = !country || response?.countryCode?.trim().toUpperCase() === country;
  const rows = verified ? response?.destinations.filter(row => row.image) : undefined;
  return rows?.length
    ? rows.map(row => ({ name: row.city, image: row.image!, carCount: row.carCount }))
    : fallback;
}

export function countryCarDestinations(
  cars: Array<{ city?: string | null; countryCode?: string | null; primaryImageUrl?: string | null }>,
  countryCode: string,
): HomeDestination[] {
  const cities = new Map<string, HomeDestination>();
  for (const car of cars) {
    if (car.countryCode?.trim().toUpperCase() !== countryCode.toUpperCase()) continue;
    const city = car.city?.trim();
    if (city && car.primaryImageUrl && !cities.has(city)) {
      cities.set(city, { name: city, image: car.primaryImageUrl });
    }
  }
  return [...cities.values()].slice(0, 8);
}
